import { WpMedia } from '@/interfaces/wp/WpMedia';
import axios from 'axios';
import { env } from '@/helpers';

class MediaAPI {
  static get(mediaId: number | `${number}` | number[] | `${number}`[]): Promise<WpMedia[]> {
    const mediaIds = !Array.isArray(mediaId) ? [mediaId] : mediaId;
    return new Promise((resolve, reject) => {
      axios.get<WpMedia[]>(`${env('API_BASE_PATH')}io-media`, {
        params: {
          include: mediaIds,
        },
      }).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        const pageResponse = e?.response?.data;
        if (pageResponse) {
          resolve(pageResponse);
        } else {
          reject(e);
        }
      });
    });
  }
}

export default MediaAPI;
